import { AppState as State } from '@ducks/index';

export const getRefreshId = (state: State) => state.qualification.refresh;
export const checkIsLoading = (state: State) => state.qualification.isLoading;
export const checkIsHistoryLoading = (state: State) => state.qualification.isHistoryLoading;
export const checkIsDetailLoading = (state: State) => state.qualification.isDetailLoading;
export const checkIsSubmitting = (state: State) => state.qualification.isSubmitting;
export const getQualifications = (state: State) => state.qualification.qualifications;
export const getQualificationDefinitions = (state: State) => state.qualification.definitions;
export const getQualificationDetail = (state: State) => state.qualification.qualificationDetail;
export const getSpecialQualifications = (state: State) => state.qualification.specialDefinitions;
export const getQualificationHistory = (state: State) => state.qualification.histories;
export const getSpecialQualificationsUsedInProperty = (state: State) => state.qualification.specialReferences;
export const getIsNavigating = (state: State) => state.qualification.isNavigating;
export const getIsNavigatingTo = (state: State) => state.qualification.isNavigatingTo;
export const getMstWorkTypes = (state: State) => state.qualification.workTypes;
export const getMstAffiliationTypes = (state: State) => state.qualification.affiliationTypes;

